import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLogin.css';

function AdminLogin() {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMessage, setForgotMessage] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(credentials.email, credentials.password);
    
    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setError(result.message);
    }
    
    setLoading(false);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotMessage('');
    setError('');

    if (!forgotEmail) {
      setError('Please enter your email address');
      return;
    }

    try {
      const response = await fetch('/.netlify/functions/api/auth/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: forgotEmail })
      });

      const data = await response.json();

      if (response.ok) {
        setForgotMessage('✅ ' + data.message);
        setForgotEmail('');
      } else {
        setError(data.message || 'Failed to request password reset');
      }
    } catch (err) {
      setError('Error: ' + err.message);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-box">
        <h1>Heritage Hub Admin</h1>
        
        {!showForgotPassword ? (
          <>
            <p className="subtitle">Secure Admin Portal</p>
            {error && <div className="error-message">{error}</div>}
            
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Username (e.g., clement@heritagehub.co.za)"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>

            <div className="forgot-password-link">
              <button 
                type="button"
                onClick={() => setShowForgotPassword(true)}
                className="link-btn"
              >
                Forgot Password?
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="subtitle">Reset Your Password</p>
            {error && <div className="error-message">{error}</div>}
            {forgotMessage && <div className="success-message">{forgotMessage}</div>}
            
            <div style={{
              background: '#f0f7ff', 
              padding: '12px', 
              borderRadius: '4px', 
              marginBottom: '15px',
              fontSize: '0.9em',
              border: '1px solid #d4af37'
            }}>
              <strong>Note:</strong> Enter your username (e.g., clement@heritagehub.co.za). 
              The password reset link will be sent to <strong>mashaba.enterprise2025@gmail.com</strong> 
              and will be specific to your username only.
            </div>
            
            <form onSubmit={handleForgotPassword}>
              <input
                type="email"
                placeholder="Your Username (e.g., clement@heritagehub.co.za)"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                required
              />
              <button type="submit">Send Reset Link</button>
            </form>

            <div className="forgot-password-link">
              <button 
                type="button"
                onClick={() => {
                  setShowForgotPassword(false);
                  setForgotMessage('');
                  setError('');
                }}
                className="link-btn"
              >
                Back to Login
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;
